module.exports = __webpack_public_path__ + "static/img/Kane-Bradley.b3b7f02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Kane-Bradley.jpg
// module id = jSOS
// module chunks = 0